/** @format */

import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { VizFormModule } from '../common/components/form/form.module';
import { utils, WebUtils } from '../common/utils';
import { TBooking } from '../core/entities';
import { SessionService } from '../session.service';



@Component({
  templateUrl: './my.booking.update.num.participants.dialog.html',
  standalone: true,
  imports: [
    VizFormModule,
    MatTabsModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatCheckboxModule,
  ],
})
export class MyBookingUpateNumParticipantsDialogComponent {
  form: UntypedFormGroup;
  _common = _common;

  object: TBooking;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    public session: SessionService,
    public http: HttpClient,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<MyBookingUpateNumParticipantsDialogComponent>
  ) {
    this.object = data.object;

    let capacity = this.object.space?.capacity ?? 0;


    let validators = []
    if (!capacity) {
      validators.push(
        Validators.required,
        Validators.min(0),
        Validators.max(9999));
    } else if (capacity == 1) {
      validators.push(
      )
    } else {
      validators.push(
        Validators.required,
        Validators.min(0),
        Validators.max(capacity - 1));
    }
    this.form = this.fb.group({
      numParticipants: ['', validators],

    });
  }

  updateForm() {

    utils.updateValidity(this.form);
  }
  save() {
    if (!this.form.valid)
      return utils.validateAllFormFields(this.form, {
        snackBar: this.snackBar,
      });
    let query = Object.assign({}, this.form.value);
    WebUtils.web_result(

      this.http.post(`/api/client/booking/${this.object.id}/num-participants`, {
        ... this.form.value,
      }),
      async (result) => {

        this.dialogRef.close(query);
      }
    )
  }

  cancel() {
    this.dialogRef.close();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
